import * as Sentry from '@sentry/react';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { BrowserTracing } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import config from './constants/config';
import reportWebVitals from './reportWebVitals';

if (config.sentry.sentryDsn) {
  Sentry.init({
    dsn: config.sentry.sentryDsn,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
    environment: config.environment,
    maxValueLength: 1000,
  });
}

if (config.ga.gaId) {
  ReactGA.initialize(config.ga.gaId);
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
